module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/mlb/survive-ff414a50c9f4f81971968436faf0bbfb.svg";